// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bdCEs","top":"styles_top__CROfr","left":"styles_left__aXTXx","description":"styles_description__2QR5n"};